import { render, staticRenderFns } from "./ProfileSidebar.vue?vue&type=template&id=9c777642&"
import script from "./ProfileSidebar.vue?vue&type=script&lang=js&"
export * from "./ProfileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports